import 'base/js/main'

if ('serviceWorker' in navigator) {
	navigator.serviceWorker
		.register('/dinozoo-sw.js')
		.then((registration) => {
			console.log('Service worker registered', registration)
		})
		.catch((err) => {
			console.error('SW registration failed', err)
		})
}
